import Cookies from 'js-cookie'
import { Dictionary } from 'vue-router/types/router'

type queryStringType = Dictionary<string | (string | null)[]>
const utmValidKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_id', 'utm_term', 'utm_content']
const UtmExpires = 1 / 48 // expire in 30min, because the default GA4 session timeout is 30 minutes

export const setupUtm = (queryString: queryStringType):void => {
  const utmDataFiltered = Object.fromEntries(Object.entries(queryString).filter(([key]) => utmValidKeys.includes(key)))
  if (Object.keys(utmDataFiltered).length !== 0) {
    Cookies.set('utm', JSON.stringify(utmDataFiltered), { expires: UtmExpires })
  }
}

export const getUtm = (): queryStringType => {
  const data = Cookies.get('utm')
  if (!data) return {}

  return JSON.parse(data)
}

export const removeUtm = ():void => {
  Cookies.remove('utm')
}
